import React, { Component } from 'react'
import { withI18n, withI18nProps } from '@lingui/react'
import noop from 'lodash/noop'
import compose from 'lodash/fp/compose'

import refsForwarder from 'client/shared/decorators/refs-forwarder'

import { AdjustableTextarea } from 'client/shared/blocks/adjustable-textarea'
import { UserAvatar } from 'client/shared/blocks/user-avatar'
import { CommentReply } from 'client/bookmate/blocks/comment-reply'

import { CurrentUserState } from 'client/shared/types/current-user'

import './comment-form.styl'

const ENTER_KEY = 13
const BACKSPACE_KEY = 8

type Props = {
  currentUser: CurrentUserState
  parent: Record<string, unknown>
  onReplyRemove: () => void
  onCommentAdd: () => void
  forwardedRef?: () => void
} & withI18nProps

class _CommentForm extends Component<Props> {
  static defaultProps = {
    forwardedRef: noop,
  }

  state = {
    autoFocus: false,
    commentText: '',
  }

  constructor(props) {
    super(props)
    props.forwardedRef(this)
  }

  componentDidMount() {
    if (window.location.hash === '#comment-form') {
      this.setState({ autoFocus: true })
    }
  }

  changeCommentText = text => {
    this.setState({
      commentText: text,
    })
  }

  handleKeyDown = e => {
    const { commentText } = this.state
    const { parent, onReplyRemove } = this.props
    const trimmedText = commentText.trim()

    switch (e.keyCode) {
      case ENTER_KEY:
        if (!e.shiftKey && trimmedText) {
          e.preventDefault()
          this.onCommentAdd(commentText)
          e.target.blur()
        }

        break
      case BACKSPACE_KEY:
        if (!trimmedText && parent) {
          e.preventDefault()
          onReplyRemove()
        }

        break
    }
  }

  onCommentAdd(content) {
    const { onCommentAdd, parent } = this.props

    onCommentAdd(content, parent)
    this.setState({
      commentText: '',
    })
  }

  focus(): void {
    this.refs.textArea.focus()
  }

  render(): JSX.Element {
    const { i18n, currentUser, parent } = this.props
    const { commentText, autoFocus } = this.state

    return (
      <div className="comment-form">
        <div className="comment-form__avatar">
          <UserAvatar user={currentUser} size={40} />
        </div>
        <div className="comment-form__field">
          {parent && <CommentReply {...parent} kind="in-form" />}
          <AdjustableTextarea
            ref="textArea"
            className="comment-form__textarea"
            autoFocus={autoFocus}
            content={commentText}
            placeholder={i18n.t`comments.textarea_placeholder`}
            onKeyDown={this.handleKeyDown}
            onChange={this.changeCommentText}
            id="CommentForm_textarea"
          />
        </div>
      </div>
    )
  }
}

const wrappers = compose(refsForwarder, withI18n({ update: true }))

export const CommentForm = wrappers(_CommentForm)
